<article class="gup-C-layoutNav"  [class.gup-C-layoutNav--isBaseTest]="isBaseTest" #navigation>

    <figure class="gup-C-layoutNav__head"
            (click)="navigateToHome()">
        <img src="../../../../assets/210329_L_Up_gestion_exp_W1_RVB.svg" class="gup-O-logo" alt="Logo UpExpert"/>
    </figure>

    <div class="gup-C-layoutNav__main">

        <ul class="gup-O-list -vertical">

            <ng-container *ngFor="let menu of displayedMenusList">

                <li class="gup-O-list__item"
                    (click)="selectMenu(menu)">

                    <a class="gup-O-list__link"
                       [class.-is-active]="isActive(menu) || selectedMenu?.Id === menu.Id">

                        <span>{{ menu.Libelle }}</span>

                    </a>

                </li>

            </ng-container>

        </ul>

    </div>

    <!-- sub menu -->
    <ng-template #subNavigation="cdkPortal" cdkPortal>

        <div class="gup-C-subMenu__content">

            <!-- quand on déploie le sous-menu, on affiche l'icone ici-->
            <a (click)="closeMenu()"
               class="gup-O-slideButton">
                <kal-icon>chevron_left</kal-icon>
            </a>

            <nav class="gup-O-list -vertical">

                <div class="gup-O-list__item gup-C-subMenu__filAriane xsmall">

                    <span *ngFor="let menu of previousMenusList | slice:0:previousMenusList.length - 1"
                          (click)="previousMenu(menu)">
                        {{ menu.Libelle }}
                    </span>

                </div>

                <div class="gup-C-subMenu__title big">

                    <div *ngIf="currentSubMenu?.ParentMenu"
                         (click)="previousMenu(previousMenusList[previousMenusList.length - 2])">

                        <kal-icon> keyboard_arrow_left</kal-icon>

                        <span>{{currentSubMenu.Libelle}}</span>

                    </div>

                </div>

                <div class="gup-U-margin-bottom--small">
                    <kal-input placeholder="Rechercher un menu..."
                               [formControl]="searchbarControl"
                               icon="search"
                               kalTheme="reverse">
                    </kal-input>
                </div>

                <div class="gup-C-subMenu__liste">

                    <div *ngIf="(displayedSubMenusList | arrayEmpty) && searchbarControl.value"
                         class="gup-O-list__item">
                        <span class="gup-U-color--300">Aucun résultat</span>
                    </div>

                    <ng-container *ngFor="let subMenu of displayedSubMenusList">

                        <div class="gup-O-list__item">

                            <div class="gup-O-list__link"
                                 (click)="selectSubMenu(subMenu)">

                                <a
                                    [class.-is-active]="isActive(subMenu)">
                                    {{ subMenu.Libelle }}
                                </a>

                                <kal-icon *ngIf="hasChildren(subMenu)">
                                    keyboard_arrow_right
                                </kal-icon>

                            </div>

                        </div>

                    </ng-container>

                    <kal-button *ngIf="selectedMenu.Code === 'WEB_ADMINISTRATION'"
                                (click)="openPortalDialog()"
                                class="gup-C-subMenu__btnWebAccess">

                        <kal-icon>web</kal-icon>

                        <div>

                            <div>Accéder</div>

                            <div>au site internet</div>

                        </div>

                    </kal-button>

                </div>

            </nav>

        </div>

    </ng-template>

    <div class="gup-C-layoutNav__foot">

        <div class="gup-O-list gup-O-list -vertical">

            <div class="gup-O-separationLine"></div>

            <div class="gup-O-list__item">

                <a class="gup-O-list__link help" href="https://expert.123ce.net" target="_blank">
                    <kal-icon>help_outline</kal-icon>
                    <div>Aide en ligne</div>
                </a>

            </div>

            <div class="gup-O-list__item"
                 (click)="openDelegationChoiceDialog()">

                <a class="gup-O-list__link">
                    <kal-icon>business</kal-icon>
                    <span kalTooltip="{{ceName$ | async}}">
                        <div>{{ceName$ | async}}</div>
                    </span>
                </a>

            </div>

            <div class="gup-O-list__item" *ngIf="user$ | async as user">
                <a class="gup-O-list__link">

                    <kal-icon>account_circle</kal-icon>
                    <div (click)="openEditPassword()" kalTooltip="Modifier mon mot de passe">{{user?.Prenom}} {{user?.Nom}}</div>
                </a>

            </div>

            <div class="gup-O-list__item"
                 (click)="logOut()">

                <a class="gup-O-list__link">
                    <kal-icon>exit_to_app</kal-icon>
                    <div>Se déconnecter</div>
                </a>

            </div>

        </div>

    </div>

</article>
